module.exports = __webpack_public_path__ + "img/Group 73.4818b620.png";